/* eslint-disable-next-line no-unused-vars */
const debug = require('debug')('combat');

class Combat {
  constructor(party) {
    this.party = party;
    this.stats = this.calculateStats(party);
  }

  calculateStats() {
    const party = this.party;
    const luck = party.traits.getTraitValue('luck') || 1;
    const resilience = party.traits.getTraitValue('resilience') || 1;
    const canUseGun = party.resources.attribs.ammo.value > 0;
    this.stats = {
      attackPower: canUseGun ? 15 : 5, // 25 : 10
      defense: 5 + resilience,
      agility: 7, // 12
      speed: 10, // 15
      intelligence: 5,
      specialAbilities: []
    };
    return this.stats;
  }

  getStats() {
    return this.calculateStats();
  }
}

export default Combat;
